import React from "react";
import { useDiscontinueFeedback } from "./hook";
import {
  getFormattedDate,
  getFormattedTime,
} from "../../../common/utils/methods/commonMethods/utilityMethod";
import { useModal } from "../../../../../../contexts/customModal";
import AButton from "../../../common/form-fields-mui/AButton";

const Feedback = ({ feedbacks }) => {
  return (
    <div>
      <div>
        {feedbacks.map((feedback) => (
          <div className="mb-4" key={feedback.id}>
            <div>{feedback?.reason}</div>
            <div>{feedback?.feedback}</div>
            <div className="label-color regular-small ">
              {getFormattedDate(feedback?.createdOn, "DD-MM-YYYY")} at{" "}
              {getFormattedTime(feedback?.createdOn)}| {feedback?.createdBy}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const DiscontinueFeedback = ({ applicationId }) => {
  const feedbacks = useDiscontinueFeedback({ applicationId });

  const { showModal } = useModal();

  const handleOpenModal = async () => {
    return showModal({
      title: "Feedback Details",
      content: <Feedback feedbacks={feedbacks} />,
    });
  };
  if (!feedbacks?.length) return null;
  return (
    <AButton size="xs" onClick={handleOpenModal}>
      User Feedback
    </AButton>
  );
};

export default DiscontinueFeedback;
